'use strict';

var cov_1tsof8avtl = function () {
  var path = '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/type.js',
      hash = 'd25d951026d03171aa7694b1c6850694dea2a628',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src2823567348/src/apps/tnwi/temp/nucleo/filter/lib/type.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 26
        },
        end: {
          line: 11,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterType = exports.FilterType = (cov_1tsof8avtl.s[0]++, _propTypes2.default.shape({
  minPrice: _propTypes2.default.number,
  maxPrice: _propTypes2.default.number,
  date: _propTypes2.default.string,
  fromDate: _propTypes2.default.string,
  toDate: _propTypes2.default.string,
  selectedSite: _propTypes2.default.array,
  selectedTeam: _propTypes2.default.array
}));

exports.default = FilterType;